import {Pipe, PipeTransform} from '@angular/core';
import {LocationDetailsResponse} from '../models/LocationDetailsResponse.model';
import {TerraUtils} from '../TerraUtils';

@Pipe({
  name: 'locationToString'
})
export class LocationToStringPipe implements PipeTransform {

  transform(location: LocationDetailsResponse, args: 'full' | 'short'): string {
    if (args === 'full') {
      if (!!location) {
        let locationDetails = '';
        let cityDetails = '';
        let countryDetails = '';

        if (location.houseNumber) {
          cityDetails = `${location.houseNumber} `;
        }

        if (location.streetName) {
          cityDetails += `${location.streetName} `;
        }

        if (location.cityName) {
          cityDetails += `${location.cityName} `;
        }

        if (!!location.country) {
          if (location.country.code === TerraUtils.consts.countryCode.US) {
            countryDetails += `${location.stateName ? location.stateName.concat(', ') : ''}${location.country?.name || ''}`;
          }
          else {
            countryDetails += `${location.country?.name || ''}`;
          }
        }

        if (cityDetails && countryDetails) {
          locationDetails = `${cityDetails.trim()}, ${countryDetails.trim()}`
        }
        else {
          locationDetails = cityDetails.trim() || countryDetails.trim();
        }

        return locationDetails;
      }
    }
    else if (args === 'short') {
      if (!!location && !!location.country) {
        return `${location.cityName || ''}${location.cityName ? ',' : ''} ${location.country.code || ''}`;
      }
      else if (!!location) {
        return `${location.cityName}`
      }
    }

    return '';
  }

}
